<div class="colheader">
  <mat-icon class="icon-bottom me-1">task</mat-icon>
  {{ 'FLIGHT.PROBLEM_FLIGHTS' | transloco }} {{problemFlightsDataSource.data?.length}}
</div>
<div class="overflow-auto">
  <table mat-table class="mat-elevation-z8"
    [dataSource]="problemFlightsDataSource.data?.length > 0 ? problemFlightsDataSource : emptyData" matSort>

    <ng-container matColumnDef="orderNr">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'ORDER_LIST.ORDER_NR' | transloco }}</th>
      <td mat-cell *matCellDef="let element">{{element.orderNr}}</td>
    </ng-container>

    <ng-container matColumnDef="problemType">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'FLIGHT.PROBLEM' | transloco }}</th>
      <td mat-cell *matCellDef="let element">{{ element.problemType | transloco }}</td>
    </ng-container>

    <ng-container matColumnDef="code">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'FLIGHT.FLIGHT_CODE' | transloco }}</th>
      <td mat-cell *matCellDef="let element">{{element.code}}</td>
    </ng-container>

    <ng-container matColumnDef="scheduled">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'FLIGHT.SCHEDULED' | transloco }}</th>
      <td mat-cell *matCellDef="let element">
        <span>
          {{element.scheduled | date:'yyyy-MM-dd HH:mm'}}
        </span>
        <mat-icon class="icon-bottom mx-3">{{element.icon}}</mat-icon>
      </td>
    </ng-container>

    <ng-container matColumnDef="estimated">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'FLIGHT.ESTIMATED' | transloco }}</th>
      <td mat-cell *matCellDef="let element">
        <span>
          {{element.estimated | date:'yyyy-MM-dd HH:mm'}}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="empty-row">
      <td mat-cell class="no-data-cell" *matCellDef="let element">{{ 'ERROR.NO_DATA' | transloco }}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row class="py-2"
      *matRowDef="let row; columns: problemFlightsDataSource.data.length > 0 ? displayedColumns : ['empty-row'];"
      (click)="goToOrder(row.orderId)" class="clickable"></tr>
  </table>
</div>